import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt22 } from './phonics/phonics_data_lt22';

function PhonicsLt22() {
  return <PhonicsLt letterData={letterDataLt22} />;
}

export default PhonicsLt22;
